import { ButtonConfigWithId } from '../components/CustomButton'
import { TextPropsWithId } from '../components/TopSection'
import { AppState } from '../state/fixedAppState'

export interface Config {
  name: 'corporateFixed' | 'privateFixed'
  topText: TextPropsWithId[]
  buttons: ButtonConfigWithId[]
  defaultState: AppState
}

let id = 0
export const CORPORATE_FIXED_CONFIG: Config = {
  name: 'corporateFixed',
  topText: [
    {
      type: 'h2',
      text: 'Räkna ut vad en placering kan ge',
      id: id++,
    },
    {
      type: 'lead',
      text: 'Testa genom att fylla i belopp och hur länge ni vill placera pengarna.',
      id: id++,
    },
  ],
  buttons: [
    {
      href: 'https://secure.sbab.se/logga-in?rev=1698232704542&as=corporate&v=latest',
      text: 'Logga in och öppna placeringskonto',
      variant: 'primary',
      id: id++,
    },
    {
      href: 'https://www.sbab.se/1/foretag__bostadsrattsforeningar/spara/sparande/ansok_om_sbab-konto.html',
      text: 'Öppna ett SBAB-konto',
      variant: 'secondary',
      id: id++,
    },
  ],
  defaultState: {
    interestRateObjs: [],
    placementAmount: 2_000_000,
    interestRateIndex: 0,
    hasAppError: false,
    calculationState: 'ok',
    userIsTyping: false,
  },
}

export const PRIVATE_FIXED_CONFIG: Config = {
  name: 'privateFixed',
  topText: [
    {
      type: 'h2',
      text: 'Se vad ett fasträntekonto kan ge dig',
      id: id++,
    },
    {
      type: 'lead',
      text: 'Testa dig fram genom att fylla i belopp och hur länge du vill binda pengarna.',
      id: id++,
    },
  ],
  buttons: [
    {
      href: 'https://secure.sbab.se/logga-in?dep=privat&redirect=/sparkonto&content=first',
      text: 'Logga in och öppna fasträntekonto',
      variant: 'primary',
      id: id++,
    },
    {
      href: 'https://secure.sbab.se/logga-in?dep=privat&redirect=/sparkonto/oppna&content=second',
      text: 'Öppna sparkonto',
      variant: 'secondary',
      id: id++,
    },
  ],
  defaultState: {
    interestRateObjs: [],
    placementAmount: 10_000,
    interestRateIndex: 0,
    hasAppError: false,
    calculationState: 'ok',
    userIsTyping: false,
  },
}
